var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HomeHeader'),_c('Tags'),_c('FeaturedStores',{attrs:{"horizontal":false}}),_c('BottomNavigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }